module.exports = __webpack_public_path__ + "img/subBanner17.36024131.png";